module.exports = __webpack_public_path__ + "img/UPS-black.4ef48d89.png";